import React, { useMemo, useState } from "react";

function SuperAdmin() {
  const usersData = [
    {
      id: 1,
      name: "Sesha",
      role: "HR Manager",
      department: "Human Resource",
      email: "sesha@company.com",
      status: "Active",
      lastLogin: "2 mins ago",
      avatar:
        "https://ui-avatars.com/api/?name=Sesha&background=0D6EFD&color=fff",
    },
    {
      id: 2,
      name: "Pooja Mohanraj",
      role: "Employee",
      department: "Development",
      email: "pooja@company.com",
      status: "Inactive",
      lastLogin: "1 day ago",
      avatar:
        "https://ui-avatars.com/api/?name=Pooja+Mohanraj&background=6610F2&color=fff",
    },
    {
      id: 3,
      name: "Ajith",
      role: "Team Lead",
      department: "Sales",
      email: "ajith@company.com",
      status: "Active",
      lastLogin: "10 mins ago",
      avatar:
        "https://ui-avatars.com/api/?name=Ajith&background=198754&color=fff",
    },
    {
      id: 4,
      name: "Micheal",
      role: "Manager",
      department: "Operations",
      email: "micheal@company.com",
      status: "Active",
      lastLogin: "18 mins ago",
      avatar:
        "https://ui-avatars.com/api/?name=Micheal&background=198754&color=fff",
    },
  ];

  const modules = [
    {
      name: "Dashboard",
      icon: "fa-chart-line",
      color: "#0d6efd",
    },
    {
      name: "Employee",
      icon: "fa-users",
      color: "#20c997",
    },
    {
      name: "Attendance",
      icon: "fa-calendar-check",
      color: "#fd7e14",
    },
    {
      name: "Payroll",
      icon: "fa-money-bill-wave",
      color: "#dc3545",
    },
    {
      name: "Recruitment",
      icon: "fa-user-plus",
      color: "#6f42c1",
    },
    {
      name: "Performance",
      icon: "fa-chart-pie",
      color: "#198754",
    },
    {
      name: "Reports",
      icon: "fa-file-alt",
      color: "#0dcaf0",
    },
    {
      name: "Settings",
      icon: "fa-cogs",
      color: "#6c757d",
    },
  ];

  const defaultPermissions = modules.reduce((acc, module) => {
    acc[module.name] = {
      view: true,
      add: false,
      edit: false,
      delete: false,
      export: false,
      approve: false,
    };
    return acc;
  }, {});

  const [selectedUser, setSelectedUser] = useState(usersData[0]);
  const [permissions, setPermissions] = useState(defaultPermissions);
  const [search, setSearch] = useState("");

  const filteredUsers = useMemo(() => {
    return usersData.filter((user) =>
      user.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search]);

  const handlePermission = (module, type) => {
    setPermissions((prev) => ({
      ...prev,
      [module]: {
        ...prev[module],
        [type]: !prev[module][type],
      },
    }));
  };

  const activePermissions = Object.values(permissions).reduce((acc, item) => {
    return (
      acc +
      Object.values(item).filter((permission) => permission === true).length
    );
  }, 0);

  return (
    <div
      className="container-fluid p-4"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #eef2ff 0%, #f8fbff 40%, #ffffff 100%)",
      }}
    >
      {/* TOP NAVBAR */}
      <div
        className="d-flex justify-content-between align-items-center px-4 py-3 mb-4"
        style={{
          background: "rgba(255,255,255,0.8)",
          backdropFilter: "blur(12px)",
          borderRadius: "24px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.06)",
        }}
      >
        <div>
          <h2 className="fw-bold mb-1">
            <i className="fas fa-user-shield text-primary me-2"></i>
            HRMS Super Admin
          </h2>

          <p className="text-muted mb-0">
            Advanced Role & Permission Management System
          </p>
        </div>

        <div className="d-flex align-items-center gap-3">
          <button className="btn btn-light rounded-pill px-4 shadow-sm">
            <i className="fas fa-bell me-2"></i>
            Notifications
          </button>

          <button className="btn btn-primary rounded-pill px-4 shadow">
            <i className="fas fa-save me-2"></i>
            Save Changes
          </button>
        </div>
      </div>

      {/* STATISTICS */}
      <div className="row g-4 mb-4">
        {[
          {
            title: "Total Users",
            value: "248",
            icon: "fa-users",
            color: "#0d6efd",
          },
          {
            title: "Active Roles",
            value: "18",
            icon: "fa-user-lock",
            color: "#20c997",
          },
          {
            title: "Permissions",
            value: activePermissions,
            icon: "fa-key",
            color: "#fd7e14",
          },
          {
            title: "Pending Approval",
            value: "12",
            icon: "fa-clock",
            color: "#dc3545",
          },
        ].map((card, index) => (
          <div className="col-lg-3 col-md-6" key={index}>
            <div
              className="p-4 h-100"
              style={{
                borderRadius: "24px",
                background: "white",
                boxShadow: "0 10px 35px rgba(0,0,0,0.06)",
                transition: "0.3s",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <p className="text-muted mb-2">{card.title}</p>
                  <h2 className="fw-bold">{card.value}</h2>
                </div>

                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "20px",
                    background: `${card.color}15`,
                  }}
                >
                  <i
                    className={`fas ${card.icon}`}
                    style={{
                      color: card.color,
                      fontSize: "28px",
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        {/* LEFT PANEL */}
        <div className="col-xl-4">
          <div
            className="p-4 h-100"
            style={{
              borderRadius: "24px",
              background: "white",
              boxShadow: "0 10px 35px rgba(0,0,0,0.06)",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="fw-bold mb-0">
                <i className="fas fa-users text-primary me-2"></i>
                Team Members
              </h4>

              <button className="btn btn-primary rounded-pill">
                <i className="fas fa-plus me-2"></i>
                Add User
              </button>
            </div>

            {/* SEARCH */}
            <div className="position-relative mb-4">
              <i
                className="fas fa-search position-absolute"
                style={{
                  top: "50%",
                  left: "18px",
                  transform: "translateY(-50%)",
                  color: "#6c757d",
                }}
              ></i>

              <input
                type="text"
                placeholder="Search employee..."
                className="form-control border-0 shadow-none"
                style={{
                  background: "#f3f6fb",
                  borderRadius: "16px",
                  padding: "14px 18px 14px 48px",
                }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {/* USER LIST */}
            <div
              style={{
                maxHeight: "650px",
                overflowY: "auto",
              }}
            >
              {filteredUsers.map((user) => (
                <div
                  key={user.id}
                  onClick={() => setSelectedUser(user)}
                  className="mb-3 p-3"
                  style={{
                    borderRadius: "20px",
                    cursor: "pointer",
                    border:
                      selectedUser.id === user.id
                        ? "2px solid #0d6efd"
                        : "2px solid transparent",
                    background:
                      selectedUser.id === user.id
                        ? "linear-gradient(135deg,#eef4ff,#ffffff)"
                        : "#fff",
                    transition: "0.3s",
                    boxShadow:
                      selectedUser.id === user.id
                        ? "0 10px 25px rgba(13,110,253,0.12)"
                        : "0 5px 18px rgba(0,0,0,0.04)",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={user.avatar}
                      alt=""
                      style={{
                        width: "65px",
                        height: "65px",
                        borderRadius: "18px",
                        objectFit: "cover",
                      }}
                    />

                    <div className="ms-3 flex-grow-1">
                      <h6 className="fw-bold mb-1">{user.name}</h6>

                      <div className="text-muted small mb-1">
                        {user.role}
                      </div>

                      <div className="small text-secondary">
                        <i className="fas fa-clock me-1"></i>
                        {user.lastLogin}
                      </div>
                    </div>

                    <div>
                      <span
                        className={`badge rounded-pill px-3 py-2 ${
                          user.status === "Active"
                            ? "bg-success-subtle text-success"
                            : "bg-danger-subtle text-danger"
                        }`}
                      >
                        {user.status}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="col-xl-8">
          <div
            className="p-4"
            style={{
              borderRadius: "24px",
              background: "white",
              boxShadow: "0 10px 35px rgba(0,0,0,0.06)",
            }}
          >
            {/* USER PROFILE */}
            <div
              className="p-4 mb-4"
              style={{
                borderRadius: "24px",
                background:
                  "linear-gradient(135deg,#0d6efd 0%,#4f46e5 100%)",
                color: "white",
              }}
            >
              <div className="d-flex align-items-center">
                <img
                  src={selectedUser.avatar}
                  alt=""
                  style={{
                    width: "90px",
                    height: "90px",
                    borderRadius: "24px",
                    border: "4px solid rgba(255,255,255,0.2)",
                  }}
                />

                <div className="ms-4">
                  <h3 className="fw-bold mb-1">{selectedUser.name}</h3>

                  <div className="mb-2">
                    {selectedUser.role} • {selectedUser.department}
                  </div>

                  <div className="d-flex gap-3">
                    <span>
                      <i className="fas fa-envelope me-2"></i>
                      {selectedUser.email}
                    </span>

                    <span>
                      <i className="fas fa-circle text-success me-2"></i>
                      {selectedUser.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* TOP ACTIONS */}
            <div className="d-flex flex-wrap gap-3 mb-4">
              <button className="btn btn-primary rounded-pill px-4">
                <i className="fas fa-user-edit me-2"></i>
                Edit User
              </button>

              <button className="btn btn-success rounded-pill px-4">
                <i className="fas fa-clone me-2"></i>
                Clone Permission
              </button>

              <button className="btn btn-warning rounded-pill px-4 text-white">
                <i className="fas fa-history me-2"></i>
                Activity Logs
              </button>

              <button className="btn btn-danger rounded-pill px-4">
                <i className="fas fa-ban me-2"></i>
                Disable Access
              </button>
            </div>

            {/* PERMISSION TABLE */}
            <div className="table-responsive">
              <table className="table align-middle">
                <thead>
                  <tr
                    style={{
                      background: "#f3f6fb",
                    }}
                  >
                    <th
                      className="py-3"
                      style={{
                        borderRadius: "16px 0 0 16px",
                      }}
                    >
                      Module
                    </th>

                    {[
                      "View",
                      "Add",
                      "Edit",
                      "Delete",
                      "Export",
                      "Approve",
                    ].map((head) => (
                      <th
                        key={head}
                        className="text-center py-3"
                      >
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {modules.map((module, index) => (
                    <tr key={index}>
                      <td className="py-4">
                        <div className="d-flex align-items-center">
                          <div
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "16px",
                              background: `${module.color}15`,
                            }}
                          >
                            <i
                              className={`fas ${module.icon}`}
                              style={{
                                color: module.color,
                                fontSize: "20px",
                              }}
                            ></i>
                          </div>

                          <div>
                            <div className="fw-bold">
                              {module.name}
                            </div>

                            <small className="text-muted">
                              Manage {module.name} module
                            </small>
                          </div>
                        </div>
                      </td>

                      {[
                        "view",
                        "add",
                        "edit",
                        "delete",
                        "export",
                        "approve",
                      ].map((type) => (
                        <td className="text-center" key={type}>
                          <div className="form-check form-switch d-flex justify-content-center">
                            <input
                              type="checkbox"
                              className="form-check-input shadow-none"
                              checked={
                                permissions[module.name][type]
                              }
                              onChange={() =>
                                handlePermission(module.name, type)
                              }
                              style={{
                                width: "50px",
                                height: "24px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* FOOTER ACTIONS */}
            <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-3">
              <div className="d-flex gap-3">
                <button className="btn btn-light rounded-pill px-4 shadow-sm">
                  <i className="fas fa-undo me-2"></i>
                  Reset
                </button>

                <button className="btn btn-dark rounded-pill px-4">
                  <i className="fas fa-download me-2"></i>
                  Export Role
                </button>
              </div>

              <button className="btn btn-primary rounded-pill px-5 py-2 shadow">
                <i className="fas fa-save me-2"></i>
                Save Permissions
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SuperAdmin;